import cn from 'classnames';

import { IconCheck } from 'components/UI/Icons/Check';
import { IconInfo } from 'components/UI/Icons/Info';
import { IconAlertTriangle } from './UI/Icons/AlertTriangle';

export type SubmissionStatus =
  | 'Duplicate'
  | 'Off limits'
  | 'Needs review'
  | 'complete'
  | 'No about'
  | 'No highlights'
  | 'Add narratives';

interface SubmissionChipProps {
  status?: SubmissionStatus;
  className?: string;
}

export function SubmissionChip({
  status = 'Needs review',
  className,
}: SubmissionChipProps) {
  const getChipStyles = () => {
    switch (status) {
      case 'complete':
        return {
          container: 'bg-green-50',
          text: 'text-green-800',
          icon: 'text-green-800',
        };
      case 'No about':
      case 'No highlights':
      case 'Add narratives':
        return {
          container: 'bg-yellow-50',
          text: 'text-yellow-800',
          icon: 'text-yellow-800',
        };
      case 'Duplicate':
      case 'Off limits':
        return {
          container: 'bg-red-50',
          text: 'text-red-800',
          icon: 'text-red-800',
        };
      case 'Needs review':
      default: // 'needs review'
        return {
          container: 'bg-yellow-50',
          text: 'text-yellow-800',
          icon: 'text-yellow-800',
        };
    }
  };

  const getIcon = () => {
    switch (status) {
      case 'complete':
        return (
          <div className="flex h-3.5 w-3.5 items-center justify-center text-green-800">
            <IconCheck />
          </div>
        );
      case 'No about':
      case 'No highlights':
      case 'Add narratives':
        return (
          <div className="flex h-3.5 w-3.5 items-center justify-center text-yellow-800">
            <IconAlertTriangle />
          </div>
        );

      case 'Duplicate':
      case 'Off limits':
        return (
          <div className="flex h-3.5 w-3.5 items-center justify-center text-red-800">
            <IconAlertTriangle />
          </div>
        );

      default: // 'needs review'
        return (
          <div className="flex h-3.5 w-3.5 items-center justify-center text-yellow-800">
            <IconInfo />
          </div>
        );
    }
  };

  const getLabel = () => {
    switch (status) {
      case 'complete':
        return 'Complete';
      case 'No about':
        return 'Add about';
      case 'No highlights':
        return 'Add highlights';
      case 'Add narratives':
        return 'Add narratives';
      case 'Duplicate':
        return 'Duplicate';
      case 'Off limits':
        return 'Off limits';
      default: // 'needs review'
        return 'Needs review';
    }
  };

  const styles = getChipStyles();

  return (
    <div
      className={cn(
        'flex h-[22px] w-fit items-center gap-1 rounded-2xl px-1.5 py-[5px]',
        styles.container,
        className,
      )}
    >
      {getIcon()}
      <span className={cn('text-xs font-semibold leading-4', styles.text)}>
        {getLabel()}
      </span>
    </div>
  );
}
